// src/ga4.js
import ReactGA from "react-ga4";

const initializeGA4 = () => {
  ReactGA.initialize("G-00WW84YE32"); // Replace with your Measurement ID
};

export default initializeGA4;
